module.exports = __webpack_public_path__ + "img/ice_cold_shot_white.82da2b0a.png";